import { createPopper, Instance } from "@popperjs/core";
import { TooltipBodyElement } from "./tooltipBodyElement";

export class TooltipElement extends HTMLElement {
    private _shadowRoot: ShadowRoot;
    private p: Instance;
    private tooltip: TooltipBodyElement;
    target: any;

    constructor() {
        super();
        this._shadowRoot = this.attachShadow({ mode: "open" });
        this._shadowRoot.innerHTML = "";
    }

    private connectedCallback() {
        this.target = this.getTarget() ;
        this.target.addEventListener("mouseover", this.showTooltip);
        this.target.addEventListener("mouseout",  this.removeTooltip);
    }

    private disconnectedCallback() {
        this.removeTooltip();
        this.target.removeEventListener("mouseover", this.showTooltip);
        this.target.removeEventListener("mouseout",  this.removeTooltip);

    }

    private showTooltip = () => {
        this.tooltip = document.createElement("s6-tooltip-body") as TooltipBodyElement;
        this.tooltip.innerHTML = this.innerHTML;
        this.p = createPopper(this.target, this.tooltip, {
            placement: "bottom-start",
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [0, 8],
                    },
                },
            ],
        });
        document.body.appendChild(this.tooltip);
    }

    private removeTooltip = () => {
        if (this.p == null) {
            return;
        }
        this.p.destroy();
        if (this.tooltip != null) {
            document.body.removeChild(this.tooltip);
        }
        this.tooltip = null;
    }

    private getTarget() {
        let root = this as HTMLElement;

        let host = (this.getRootNode() as any).host;
        while (root.parentElement) {
            root = root.parentElement;
        }
        let targetSelector = this.getAttribute("for");
        if (targetSelector == null) {
            return host;
        } else {
            return host.querySelector(targetSelector);
        }
    }
}

export function initTooltipWebComponent() {
    window.customElements.define("s6-tooltip", TooltipElement);
}
